<template>
  <div class="layout" ref="layout">
      <header-component />
      <router-view/>
      <footer-component />
      <fix-component/>
  </div>
</template>
<script>
import HeaderComponent from '@/components/Header'
import FooterComponent from '@/components/Footer'
import FixComponent from '@/components/Fix'
export default {
    name:'layout',
    components:{
        HeaderComponent,
        FooterComponent,
        FixComponent
    },
   
}
</script>
<style lang="scss" scoped>
// .layout{

// }
</style>